/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import axios from "axios";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import swal from "sweetalert";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { API_HOHOLOK } from "utils";

// Data dummy untuk reports line chart
const reportsLineChartData = {
  sales: {
    labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: {
      label: "Mobile apps",
      data: [50, 40, 300, 220, 500, 250, 400, 230, 500],
    },
  },
};

// Fungsi format rupiah
function formatRupiah(angka) {
  if (!angka && angka !== 0) return "";

  // Konversi ke number untuk memastikan tipe data yang benar
  const numAngka = Number(angka);
  if (isNaN(numAngka)) return "";

  // Format angka dengan pemisah ribuan dan 2 desimal
  const formatted = numAngka.toLocaleString("id-ID", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  return "Rp " + formatted;
}

function extractProgresValue(val) {
  if (!val) return 0;
  if (typeof val === "string") {
    return parseFloat(val.replace("%", "")) || 0;
  }
  if (typeof val === "number") {
    return val;
  }
  if (val.props && typeof val.props.children === "string") {
    return parseFloat(val.props.children.replace("%", "")) || 0;
  }
  if (val.props && typeof val.props.children === "number") {
    return val.props.children;
  }
  return 0;
}

// Helper untuk mengambil data total progres per minggu dari baris total
function getTotalProgresPerMinggu(tableRows, tableColumns) {
  if (!tableRows || tableRows.length === 0) return [];
  const totalRow = tableRows[tableRows.length - 1];

  return tableColumns
    .filter((col) => col.accessor && col.accessor.startsWith("minggu_"))
    .map((col) => extractProgresValue(totalRow[col.accessor]));
}

// Tambahkan helper untuk hitung jumlah minggu dari tanggal_mulai dan tanggal_selesai
function getWeeksBetween(start, end) {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const diff = endDate - startDate;
  if (isNaN(diff) || diff < 0) return 1;
  return Math.ceil((diff + 1) / (7 * 24 * 60 * 60 * 1000));
}

// Helper untuk dapatkan tanggal awal dan akhir minggu ke-n
function getStartEndOfWeek(start, mingguKe) {
  const startDate = new Date(start);
  const awal = new Date(startDate.getTime() + (mingguKe - 1) * 7 * 86400000);
  const akhir = new Date(startDate.getTime() + (mingguKe * 7 - 1) * 86400000);
  const format = (d) => d.toISOString().slice(0, 10);
  return { awal: format(awal), akhir: format(akhir) };
}

// Helper format tanggal Indonesia
function formatTanggalIndo(dateStr) {
  if (!dateStr) return "-";
  const bulan = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(dateStr);
  if (isNaN(d)) return "-";
  return `${d.getDate()} ${bulan[d.getMonth()]} ${d.getFullYear()}`;
}

function Input_Kurva_S() {
  const { sales } = reportsLineChartData;
  const [proyekList, setProyekList] = useState([]);
  const [selectedProyek, setSelectedProyek] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openKurvaS, setOpenKurvaS] = useState(false);
  const [kurvaSForm, setKurvaSForm] = useState([
    { minggu_ke: "", progres_rencana: "" },
  ]);
  const [kurvaSLoading, setKurvaSLoading] = useState(false);
  const [selectedUtama, setSelectedUtama] = useState(null);
  const [isEditKurvaS, setIsEditKurvaS] = useState(false);
  const [dataKurvaSPerUtama, setDataKurvaSPerUtama] = useState([]);
  const [dataGrap, setDataGrap] = useState({ labels: [], datasets: {} });

  const [tahun, setTahun] = useState(new Date().getFullYear());
  // List satuan umum konstruksi

  const [tableRows, setTableRows] = useState([]);
  // Ambil semua minggu unik dari dataKurvaSPerUtama
  const mingguList = [
    ...new Set(dataKurvaSPerUtama.map((k) => k.minggu_ke)),
  ].sort((a, b) => a - b);

  // Kolom statis
  const staticColumns = [
    { Header: "Uraian Pekerjaan", accessor: "uraian_pekerjaan", width: "30%" },
    { Header: "Total Harga", accessor: "total_harga", width: "15%" },
    { Header: "Bobot (%)", accessor: "bobot", width: "10%" },
    // Kolom minggu akan ditambahkan di bawah
  ];

  // Kolom aksi
  const aksiColumn = {
    Header: "Aksi",
    accessor: "aksi",
    width: "10%",
  };
  const [tableColumns, setTableColumns] = useState([
    ...staticColumns,
    aksiColumn,
  ]);

  // Tambahkan state untuk jumlah minggu dan tanggal proyek
  const [jumlahMinggu, setJumlahMinggu] = useState(1);
  const [tanggalMulai, setTanggalMulai] = useState(null);
  const [tanggalSelesai, setTanggalSelesai] = useState(null);

  useEffect(() => {
    if (tahun) {
      fetchProyek();
    }
  }, [tahun]);

  const fetchProyek = () => {
    setLoading(true);
    axios
      .get(`${API_HOHOLOK}proyek/tahun/${tahun}`)
      .then((res) => {
        const data = res.data || [];
        const dataKU = data.map((item) => ({
          label: item.nama_proyek,
          value: item.id_proyek,
          ...item,
        }));
        setProyekList(dataKU);

        setSelectedProyek(dataKU[0]);

        setLoading(false);
      })
      .catch(() => {
        setProyekList([]);
        setLoading(false);
      });
  };

  // Set tanggal_mulai dan tanggal_selesai saat proyek dipilih
  useEffect(() => {
    if (
      selectedProyek &&
      selectedProyek.tanggal_mulai &&
      selectedProyek.tanggal_selesai
    ) {
      setTanggalMulai(selectedProyek.tanggal_mulai);
      setTanggalSelesai(selectedProyek.tanggal_selesai);
      const minggu = getWeeksBetween(
        selectedProyek.tanggal_mulai,
        selectedProyek.tanggal_selesai
      );
      setJumlahMinggu(minggu);
    }
  }, [selectedProyek]);

  // Saat openKurvaS berubah (modal dibuka), inisialisasi form sesuai jumlah minggu
  useEffect(() => {
    if (openKurvaS && jumlahMinggu && !isEditKurvaS) {
      // Jika input baru, generate array minggu
      const arr = [];
      for (let i = 1; i <= jumlahMinggu; i++) {
        arr.push({ minggu_ke: i, progres_rencana: "" });
      }
      setKurvaSForm(arr);
    }
  }, [openKurvaS, jumlahMinggu, isEditKurvaS]);

  // Fungsi untuk fetch data proyek + pekerjaan utama + sub + kurva_s
  const fetchProyekKurvas = (idProyek) => {
    axios
      .get(`${API_HOHOLOK}proyek/kurvas/${idProyek}`)
      .then((res) => {
        const data = res.data || {};
        const pekerjaanUtama = data.pekerjaan_utama || [];
        const kurvaS = data.kurva_s || [];
        // Simpan data kurva_s ke state untuk akses saat buka modal
        setDataKurvaSPerUtama(kurvaS);
        // Hitung total harga semua sub pekerjaan untuk bobot global
        let allSubs = pekerjaanUtama.flatMap((utama) =>
          (utama.sub_pekerjaan || []).map((sub) => {
            const hargaSatuan = Number(sub.harga_satuan) || 0;
            const volume = Number(sub.volume) || 0;
            const totalHarga = hargaSatuan * volume;
            return {
              id_pekerjaan_utama: utama.id_pekerjaan_utama,
              nama_pekerjaan: utama.nama_pekerjaan,
              uraian_pekerjaan: sub.uraian_pekerjaan,
              volume: sub.volume,
              satuan: sub.satuan,
              harga_satuan: hargaSatuan,
              total_harga: totalHarga,
            };
          })
        );
        const totalAll = allSubs.reduce(
          (sum, s) => sum + (s.total_harga || 0),
          0
        );
        // Baris hanya pekerjaan utama
        const rows = pekerjaanUtama.map((utama) => {
          const totalHargaUtama = (utama.sub_pekerjaan || []).reduce(
            (sum, sub) =>
              sum + (Number(sub.harga_satuan) * Number(sub.volume) || 0),
            0
          );
          const bobotUtama =
            totalAll > 0
              ? ((totalHargaUtama / totalAll) * 100).toFixed(2)
              : "0.00";
          const adaKurva = kurvaS.some(
            (k) =>
              Number(k.id_pekerjaan_utama) === Number(utama.id_pekerjaan_utama)
          );
          const row = {
            uraian_pekerjaan: <b>{utama.nama_pekerjaan}</b>,
            total_harga: <b>{formatRupiah(totalHargaUtama.toString())}</b>,
            bobot: <b>{bobotUtama}</b>,
            aksi: (
              <MDButton
                variant="contained"
                color="success"
                size="small"
                onClick={() => {
                  handleOpenKurvaSModal(utama, kurvaS);
                  setSelectedUtama(utama);
                }}
              >
                {adaKurva ? "Edit Kurva S" : "Tambah Kurva S"}
              </MDButton>
            ),
          };
          mingguList.forEach((minggu) => {
            const kurva = kurvaS.find(
              (k) =>
                Number(k.id_pekerjaan_utama) ===
                  Number(utama.id_pekerjaan_utama) &&
                Number(k.minggu_ke) === Number(minggu)
            );
            row[`minggu_${minggu}`] = kurva
              ? `${Number(kurva.progres_rencana).toFixed(2)}%`
              : "";
          });
          return row;
        });
        // Tambahkan baris total progres per minggu di paling bawah
        const totalRow = {
          uraian_pekerjaan: <b>Total</b>,
          total_harga: "",
          bobot: "",
          aksi: "",
        };
        var totPro = [];
        var labelGrap = [];
        let cumulativeTotal = 0; // Untuk menyimpan total kumulatif

        mingguList.forEach((minggu) => {
          let totalProgres = 0;
          pekerjaanUtama.forEach((utama) => {
            const kurva = kurvaS.find(
              (k) =>
                Number(k.id_pekerjaan_utama) ===
                  Number(utama.id_pekerjaan_utama) &&
                Number(k.minggu_ke) === Number(minggu)
            );
            if (kurva) {
              totalProgres += Number(kurva.progres_rencana) || 0;
            }
          });

          // Akumulasi progres: minggu 2 = minggu 1 + minggu 2, minggu 3 = minggu 1 + 2 + 3
          cumulativeTotal += totalProgres;

          totalRow[`minggu_${minggu}`] = <b>{cumulativeTotal.toFixed(2)}%</b>;

          totPro.push(cumulativeTotal);
          labelGrap.push(`Minggu ${minggu}`);
        });

        const dataGrap = {
          labels: labelGrap,
          datasets: { label: "Kurva S", color: "info", data: totPro },
        };

        setDataGrap(dataGrap);
        rows.push(totalRow);
        setTableRows(rows);
      })
      .catch(() => setTableRows([]));
  };

  useEffect(() => {
    if (!selectedProyek || !selectedProyek.value) {
      setTableRows([]);
      setTableColumns([...staticColumns, aksiColumn]);
      return;
    }
    axios
      .get(`${API_HOHOLOK}proyek/kurvas/${selectedProyek.value}`)
      .then((res) => {
        const data = res.data || {};
        const pekerjaanUtama = data.pekerjaan_utama || [];
        const kurvaS = data.kurva_s || [];
        // Ambil semua minggu unik dari data kurvaS
        const mingguListBaru = [
          ...new Set(kurvaS.map((k) => k.minggu_ke)),
        ].sort((a, b) => a - b);
        // Kolom dinamis minggu
        const mingguColumnsBaru = mingguListBaru.map((minggu) => ({
          Header: `Minggu ${minggu}`,
          accessor: `minggu_${minggu}`,
          width: "8%",
        }));
        setTableColumns([...staticColumns, ...mingguColumnsBaru, aksiColumn]);
        // Hitung total harga semua sub pekerjaan untuk bobot global
        let allSubs = pekerjaanUtama.flatMap((utama) =>
          (utama.sub_pekerjaan || []).map((sub) => {
            const hargaSatuan = Number(sub.harga_satuan) || 0;
            const volume = Number(sub.volume) || 0;
            const totalHarga = hargaSatuan * volume;
            return {
              id_pekerjaan_utama: utama.id_pekerjaan_utama,
              total_harga: totalHarga,
            };
          })
        );
        const totalAll = allSubs.reduce(
          (sum, s) => sum + (s.total_harga || 0),
          0
        );
        // Baris hanya pekerjaan utama
        const rows = pekerjaanUtama.map((utama) => {
          const totalHargaUtama = (utama.sub_pekerjaan || []).reduce(
            (sum, sub) =>
              sum + (Number(sub.harga_satuan) * Number(sub.volume) || 0),
            0
          );
          const bobotUtama =
            totalAll > 0
              ? ((totalHargaUtama / totalAll) * 100).toFixed(2)
              : "0.00";
          const adaKurva = kurvaS.some(
            (k) =>
              Number(k.id_pekerjaan_utama) === Number(utama.id_pekerjaan_utama)
          );
          const row = {
            uraian_pekerjaan: <b>{utama.nama_pekerjaan}</b>,
            total_harga: <b>{formatRupiah(totalHargaUtama.toString())}</b>,
            bobot: <b>{bobotUtama}</b>,
            aksi: (
              <MDButton
                variant="contained"
                color="info"
                size="small"
                onClick={() => {
                  handleOpenKurvaSModal(utama, kurvaS);
                  setSelectedUtama(utama);
                }}
              >
                {adaKurva ? "Edit Kurva S" : "Tambah Kurva S"}
              </MDButton>
            ),
          };
          mingguListBaru.forEach((minggu) => {
            const kurva = kurvaS.find(
              (k) =>
                Number(k.id_pekerjaan_utama) ===
                  Number(utama.id_pekerjaan_utama) &&
                Number(k.minggu_ke) === Number(minggu)
            );
            row[`minggu_${minggu}`] = kurva
              ? `${Number(kurva.progres_rencana).toFixed(2)}%`
              : "";
          });
          return row;
        });
        // Tambahkan baris total progres per minggu di paling bawah
        const totalRow = {
          uraian_pekerjaan: <b>Total</b>,
          total_harga: "",
          bobot: "",
          aksi: "",
        };
        var totPro = [];
        var labelGrap = [];
        let cumulativeTotal = 0; // Untuk menyimpan total kumulatif

        mingguListBaru.forEach((minggu) => {
          let totalProgres = 0;
          pekerjaanUtama.forEach((utama) => {
            const kurva = kurvaS.find(
              (k) =>
                Number(k.id_pekerjaan_utama) ===
                  Number(utama.id_pekerjaan_utama) &&
                Number(k.minggu_ke) === Number(minggu)
            );
            if (kurva) {
              totalProgres += Number(kurva.progres_rencana) || 0;
            }
          });

          // Akumulasi progres: minggu 2 = minggu 1 + minggu 2, minggu 3 = minggu 1 + 2 + 3
          cumulativeTotal += totalProgres;

          totalRow[`minggu_${minggu}`] = <b>{cumulativeTotal.toFixed(2)}%</b>;

          totPro.push(cumulativeTotal);
          labelGrap.push(`Minggu ${minggu}`);
        });

        const dataGrap = {
          labels: labelGrap,
          datasets: { label: "Kurva S", color: "info", data: totPro },
        };

        setDataGrap(dataGrap);
        rows.push(totalRow);
        setTableRows(rows);
      })
      .catch(() => {
        setTableRows([]);
        setTableColumns([...staticColumns, aksiColumn]);
      });
  }, [selectedProyek, dataKurvaSPerUtama]);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  // Handler form kurva S
  const handleKurvaSChange = (idx, e) => {
    const { name, value } = e.target;
    const newForm = [...kurvaSForm];
    newForm[idx][name] = value;
    setKurvaSForm(newForm);
  };
  const handleAddKurvaS = () => {
    let nextMinggu = 1;
    if (kurvaSForm.length > 0) {
      // Cari minggu_ke terbesar yang sudah ada
      const mingguList = kurvaSForm
        .map((item) => Number(item.minggu_ke))
        .filter((v) => !isNaN(v) && v > 0);
      if (mingguList.length > 0) {
        nextMinggu = Math.max(...mingguList) + 1;
      }
    }
    setKurvaSForm([
      ...kurvaSForm,
      { minggu_ke: nextMinggu, progres_rencana: "" },
    ]);
    // Fokus ke input minggu_ke baris terakhir (opsional, jika ingin autofokus, perlu ref)
  };
  const handleRemoveKurvaS = (idx) => {
    if (kurvaSForm.length === 1) return;
    setKurvaSForm(kurvaSForm.filter((_, i) => i !== idx));
  };
  const handleKurvaSSubmit = async (e) => {
    e.preventDefault();
    if (!selectedProyek) {
      swal("Pilih proyek terlebih dahulu", "", "warning");
      return;
    }
    if (!selectedUtama || !selectedUtama.id_pekerjaan_utama) {
      swal("Pilih pekerjaan utama terlebih dahulu", "", "warning");
      return;
    }
    const userStorage = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null;
    const id_admin = userStorage && userStorage.uid ? userStorage.uid : null;

    if (!id_admin) {
      swal("ID Admin tidak ditemukan di localStorage", "", "warning");
      return;
    }
    for (const item of kurvaSForm) {
      if (
        !item.minggu_ke ||
        item.progres_rencana === "" ||
        item.progres_rencana === null
      ) {
        swal("Semua minggu dan progres rencana wajib diisi!", "", "warning");
        return;
      }
      if (
        Number(item.progres_rencana) < 0 ||
        Number(item.progres_rencana) > 100
      ) {
        swal("Progres rencana harus antara 0-100", "", "warning");
        return;
      }
    }
    setKurvaSLoading(true);

    try {
      if (isEditKurvaS) {
        // Update (PUT)
        await axios.put(`${API_HOHOLOK}kurva-s`, {
          id_proyek: selectedProyek.value,
          id_admin: id_admin,
          id_pekerjaan_utama: selectedUtama.id_pekerjaan_utama,
          data: kurvaSForm.map((item) => ({
            minggu_ke: Number(item.minggu_ke),
            progres_rencana: Number(item.progres_rencana),
            id_kurva: item.id_kurva,
          })),
        });
        swal("Berhasil", "Data kurva S berhasil diupdate", "success");
      } else {
        // Input baru (POST)
        await axios.post(`${API_HOHOLOK}kurva-s`, {
          id_proyek: selectedProyek.value,
          id_admin: id_admin,
          id_pekerjaan_utama: selectedUtama.id_pekerjaan_utama,
          data: kurvaSForm.map((item) => ({
            minggu_ke: Number(item.minggu_ke),
            progres_rencana: Number(item.progres_rencana),
          })),
        });
        swal("Berhasil", "Data kurva S berhasil disimpan", "success");
      }
      setOpenKurvaS(false);
      setKurvaSForm([{ minggu_ke: "", progres_rencana: "" }]);
      // Panggil ulang fetchProyekKurvas agar tabel terupdate
      if (selectedProyek && selectedProyek.value) {
        fetchProyekKurvas(selectedProyek.value);
      }
    } catch (err) {
      swal(
        "Gagal",
        err?.response?.data?.message || "Terjadi kesalahan saat menyimpan data",
        "error"
      );
    }
    setKurvaSLoading(false);
  };

  const handleTahunChange = (newValue) => {
    setTahun(newValue);
  };

  const handleOpenKurvaSModal = (utama, kurvaS) => {
    // Bandingkan id_pekerjaan_utama sebagai number agar benar-benar konsisten
    const dataKurva = kurvaS.filter(
      (k) => Number(k.id_pekerjaan_utama) == Number(utama.id_pekerjaan_utama)
    );

    if (dataKurva.length > 0) {
      // Edit mode
      setKurvaSForm(
        dataKurva.map((item) => ({
          minggu_ke: item.minggu_ke,
          progres_rencana: item.progres_rencana,
          id_kurva: item.id_kurva, // simpan id untuk update
        }))
      );
      setIsEditKurvaS(true);
    } else {
      // Input baru, minggu_ke otomatis 1
      setKurvaSForm([{ minggu_ke: 1, progres_rencana: "" }]);
      setIsEditKurvaS(false);
    }
    setOpenKurvaS(true);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <MDBox mb={3}>
          <MDBox mb={2} display="flex" alignItems="center" gap={2}>
            <Card sx={{ width: "100%" }}>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={proyekList}
                      value={selectedProyek}
                      onChange={(event, newValue) => {
                        setSelectedProyek(newValue);
                      }}
                      loading={loading}
                      getOptionLabel={(option) => option.label || ""}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                      renderInput={(params) => (
                        <MDInput
                          {...params}
                          label="Pilih Proyek"
                          variant="standard"
                          fullWidth
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                      sx={{ minWidth: 250 }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    <Autocomplete
                      options={[2024, 2025, 2026, 2027, 2028, 2029]}
                      value={tahun || 2025}
                      onChange={(event, newValue) => {
                        if (typeof handleTahunChange === "function") {
                          handleTahunChange(newValue);
                        } else {
                          setTahun && setTahun(newValue);
                        }
                      }}
                      getOptionLabel={(option) => option.toString()}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Tahun"
                          variant="standard"
                          fullWidth
                        />
                      )}
                      sx={{ minWidth: 120 }}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </MDBox>

          {selectedProyek && (
            <MDBox
              mt={1}
              p={3}
              borderRadius={2}
              bgcolor="#f0f4fa"
              boxShadow={2}
            >
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <MDTypography
                    variant="h6"
                    fontWeight="bold"
                    color="info.main"
                    mb={1}
                  >
                    {selectedProyek.label}
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    <b>Lokasi:</b> {selectedProyek.lokasi || "-"}
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    <b>Desa:</b> {selectedProyek.desa || "-"}
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    <b>Koordinat:</b>{" "}
                    {selectedProyek.latitude && selectedProyek.longitude
                      ? `${selectedProyek.latitude}, ${selectedProyek.longitude}`
                      : "-"}
                  </MDTypography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <MDTypography variant="body2" color="text">
                    <b>Tanggal Mulai:</b>{" "}
                    {formatTanggalIndo(selectedProyek.tanggal_mulai)}
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    <b>Tanggal Selesai:</b>{" "}
                    {formatTanggalIndo(selectedProyek.tanggal_selesai)}
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    <b>Konsultan Perencana:</b>{" "}
                    {selectedProyek.nama_konsultan_perencana ||
                      selectedProyek.konsultan_perencana?.nama ||
                      "-"}
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    <b>Kontraktor Pelaksana:</b>{" "}
                    {selectedProyek.nama_kontraktor_pelaksana ||
                      selectedProyek.kontraktor_pelaksana?.nama ||
                      "-"}
                  </MDTypography>
                  <MDTypography variant="body2" color="text">
                    <b>Konsultan Pengawas:</b>{" "}
                    {selectedProyek.nama_konsultan_pengawas ||
                      selectedProyek.konsultan_pengawas?.nama ||
                      "-"}
                  </MDTypography>
                </Grid>
              </Grid>
            </MDBox>
          )}
          <Card>
            <MDBox p={3} lineHeight={1}>
              <MDTypography variant="h5" fontWeight="medium">
                Daftar Pekerjaan Proyek
              </MDTypography>
              <MDTypography variant="button" color="text">
                Tabel pekerjaan utama dan sub pekerjaan proyek terpilih.
              </MDTypography>
            </MDBox>
            <DataTable
              table={{ columns: tableColumns, rows: tableRows }}
              entriesPerPage={{ defaultValue: 100, values: [100] }}
            />
          </Card>

          <Dialog
            open={openKurvaS}
            onClose={() => setOpenKurvaS(false)}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>
              {isEditKurvaS ? "Edit Kurva S" : "Tambah Kurva S"}
            </DialogTitle>
            <form onSubmit={handleKurvaSSubmit}>
              <DialogContent dividers>
                <Grid container spacing={2}>
                  {kurvaSForm.map((item, idx) => {
                    const tanggalInfo = tanggalMulai
                      ? getStartEndOfWeek(tanggalMulai, item.minggu_ke)
                      : null;
                    return (
                      <Grid
                        container
                        spacing={1}
                        key={idx}
                        alignItems="center"
                        sx={{ mt: 1.5, ml: 1, mr: 1 }}
                      >
                        <Grid item xs={5}>
                          <TextField
                            label={`Minggu ke-${item.minggu_ke}`}
                            name="minggu_ke"
                            value={item.minggu_ke}
                            type="number"
                            fullWidth
                            required
                            disabled
                          />
                          {tanggalInfo && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {formatTanggalIndo(tanggalInfo.awal)} s/d{" "}
                              {formatTanggalIndo(tanggalInfo.akhir)}
                            </Typography>
                          )}
                        </Grid>
                        <Grid item xs={7}>
                          <TextField
                            label="Progres Rencana (%)"
                            name="progres_rencana"
                            value={item.progres_rencana}
                            onChange={(e) => handleKurvaSChange(idx, e)}
                            type="number"
                            fullWidth
                            required
                            inputProps={{
                              min: 0,
                              max: 100,
                              step: 0.01,
                              inputMode: "decimal",
                            }}
                          />
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </DialogContent>
              <DialogActions>
                <MDButton color="warning" onClick={() => setOpenKurvaS(false)}>
                  Batal
                </MDButton>
                <MDButton
                  color="info"
                  type="submit"
                  variant="contained"
                  disabled={kurvaSLoading}
                >
                  Simpan
                </MDButton>
              </DialogActions>
            </form>
          </Dialog>

          <MDBox mb={2} display="flex" alignItems="center" gap={2}>
            <Card sx={{ width: "100%" }}>
              <CardContent>
                <ReportsLineChart
                  color="success"
                  title="Grafik Kurva S"
                  description={""}
                  date="updated 4 min ago"
                  chart={dataGrap}
                />
              </CardContent>
            </Card>
          </MDBox>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Input_Kurva_S;
